
import { SVGProps } from 'react';

const ContactUsCaret = ({
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.07106 8.62671L7.07031 8.62746L5.51467 7.07183L5.51543 7.07107L0 1.55564L1.55563 0L7.07106 5.51543L12.5857 0.000760414L14.1414 1.55639L8.6267 7.07107L7.07106 8.62671Z" fill="#00AEC7"/>
  </svg>
);

export default ContactUsCaret;